import { axios } from '@Root/API'

export const remove = (engagementId, studentInitiativesId) => {
	return axios.delete(`student-engagement/${engagementId}/student-initiative/${studentInitiativesId}`)
}
